import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ERPSystem } from '../models/erpsystem.model';
import { UrlService } from './url.service';

@Injectable({
  providedIn: 'root'
})
export class ErpsystemService {

	private svcUrl = '/ERPSystems';

	constructor(private http: HttpClient, private url: UrlService) { }

	getERPSystems(): Observable<ERPSystem[]> {
		return this.http.get<ERPSystem[]>(this.url.getBaseURL() + this.svcUrl);
	}

	getERPSystem(id: number): Observable<ERPSystem> {
		return this.http.get<ERPSystem>(this.url.getBaseURL() + this.svcUrl + '/' + id);
	}

	createERPSystem(item: ERPSystem): Observable<ERPSystem> {
		return this.http.post<ERPSystem>(this.url.getBaseURL() + this.svcUrl, item);
	}
}
